import React from 'react';
import LoginButton from "../../components/LoginButton/LoginButton";
import logoLight from "../../images/boarded-logo-light.svg";

import './Login.css';

function Login() {
	return (
		<div className="login-page" data-theme="dark">
			<div className="max-w-2xl w-full mx-auto px-6 py-16">
				<div className="flex flex-col items-center text-center gap-10">
					<img src={logoLight} alt="Boarded logo" className="w-28 h-28" />

					<div className="flex flex-col gap-3">
						<h1 className="text-4xl md:text-5xl font-bold tracking-tight text-base-content font-[Comfortaa]">
							boarded
						</h1>
						<p className="text-lg text-base-content/70 max-w-md mx-auto">
							The simple way to onboard new clients. Track tasks, share files, and collaborate — all in one place.
						</p>
					</div>

					<div className="w-full max-w-sm">
						<LoginButton />
					</div>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mt-4">
						<div className="flex flex-col items-center gap-3">
							<div className="rounded-full bg-primary/10 p-3">
								<i className="bi bi-chat-dots text-2xl text-primary"></i>
							</div>
							<h3 className="font-semibold text-base-content">Communicate</h3>
							<p className="text-sm text-base-content/60">
								Keep conversations with colleagues and clients together, so nothing falls through the cracks.
							</p>
						</div>
						<div className="flex flex-col items-center gap-3">
							<div className="rounded-full bg-secondary/10 p-3">
								<i className="bi bi-people text-2xl text-secondary"></i>
							</div>
							<h3 className="font-semibold text-base-content">Collaborate</h3>
							<p className="text-sm text-base-content/60">
								Work together in real time to cut your average onboarding time.
							</p>
						</div>
						<div className="flex flex-col items-center gap-3">
							<div className="rounded-full bg-accent/10 p-3">
								<i className="bi bi-arrow-repeat text-2xl text-accent"></i>
							</div>
							<h3 className="font-semibold text-base-content">Automate</h3>
							<p className="text-sm text-base-content/60">
								Templates replicate what works, so every onboarding runs the same proven playbook.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Login;
